import React from 'react';
import { NextFutureImage } from '@components/main-components/image/NextFutureImage';
import blurImage from '@components/main-components/image/blur-image';
import { SoundLogoOverlay } from '../SoundLogoOverlay';

export const GenreCard = ({
  label,
  backgroundColor,
  imgUrl,
  isPriorityImage = false,
  onClick,
}: {
  label: string;
  backgroundColor: string;
  imgUrl: string;
  isPriorityImage?: boolean;
  onClick: () => void;
}) => {
  const GENRE_IMAGE_SIZE = 96;

  return (
    <div
      className="duration-6000 relative h-[116px] cursor-pointer overflow-hidden rounded-lg bg-black transition-all ease-in-out hover:brightness-[116%] md:h-[165px] md:w-full"
      style={{ backgroundColor: backgroundColor }}
      onClick={onClick}
    >
      <p className="absolute z-above1 px-4 py-3 font-title text-title-s font-medium text-white md:text-title-m">
        {label}
      </p>
      <div className="relative top-0 overflow-hidden">
        <SoundLogoOverlay className="relative h-[165px] rounded-lg" />
        <div className="z-0 absolute top-0 h-[100px] w-[178px] rounded-lg" />
      </div>
      <div className="absolute right-0 top-10">
        <NextFutureImage
          placeholder="blur"
          blurDataURL={blurImage(GENRE_IMAGE_SIZE, GENRE_IMAGE_SIZE)}
          src={imgUrl}
          alt="genre image"
          width={96}
          height={96}
          priority={isPriorityImage}
          style={{
            borderRadius: 8,
          }}
        />
      </div>
    </div>
  );
};
